import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { DealerRequestModel, DealerViewModel } from '../../../business-entities/dealer-view-model';
import { MechanicList } from '../../../business-entities/mechanicList-model';
import { MechanicService } from '../../../business-services/mechanic.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { TimeStampReportModel, TimeStampRequestModel, TimeStampResponseModel } from '../../../business-entities/time-stamp-report-model';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-time-stamp-report',
  templateUrl: './time-stamp-report.component.html',
  styleUrls: ['./time-stamp-report.component.css']
})
export class TimeStampReportComponent implements OnInit {
  dealerList: DealerViewModel[] = [];
  dealers: DealerViewModel[] = [];
  dealerId: string = null;
  isDealerRequired: boolean = false;
  isMechanicRequired: boolean = false;
  isMechanicSelected: boolean;
  selectedMechanic: number;
  mechanicList: MechanicList[] = [];
  dealerRequestModel: DealerRequestModel = {
    keyLocation: false,
    onlinePayment: false,
    isAdvanceSearch: false,
    statusId: 0,
    isAllDealer: false,
    isForList: false
  };
  mechanicId: any;
  isSearched: boolean = false;
  dealerName: string;
  timeStampList: TimeStampResponseModel[] = [];
  totalCount: number = 0;
  requestModel: TimeStampRequestModel = {
    dealerId: '',
    mechanicId: 0,
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    dateRange: '',
    serachTerm: '',
    workOrder: '',
    IsDocument: false
  };
  scrollDistance = 1;
  throttle = 100;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({}, {
    containerClass: 'theme-dark-blue',
    displayMonths: 1,
    showWeekNumbers: false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  stampInDate: any[];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  modal: any;
  entityId: number;
  timeStampDetails: TimeStampResponseModel[] = [];
  timeStampReport: TimeStampReportModel[] = [];
  language: any;
  isSingleDateSelected: boolean;
  dateTimeFormat: string = 'dd.MM.yyyy, HH:mm:ss';

  // Export-specific variables (similar to mechanic report pattern)
  IsDocument: boolean = false;
  exportTimeStampList: TimeStampResponseModel[] = [];
  exportTimeStampReport: TimeStampReportModel[] = [];

  constructor(
    public mechanicService: MechanicService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private translate: TranslateService,
    private toastr: ToastrService,
    private cookieservice: CookieService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,
    private userService: UserDataService
  ) { }

  ngOnInit(): void {
    this.dealerId = this.userService.currentUserValue.defaultDealerId ?? null;
    this.setDefaultCurrentMonth();
    this.GetAll();
  }

  private setDefaultCurrentMonth(): void {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    this.stampInDate = [];
    this.stampInDate.push(firstDayOfMonth);
    this.stampInDate.push(lastDayOfMonth);
  }

  GetAll() {
    this.mechanicService.GetDealerList(this.dealerRequestModel).then(data => {
      this.dealerList = data.responseObject;
      for (let value of this.dealerList) {
        this.dealers.push(value);
      }
      if (this.dealerList.length === 1) {
        this.dealerId = this.dealers[0].dealerId;
        this.GetMechanicList(this.dealerId ?? '');
      }
      else if(this.dealerId != ''){
        this.GetMechanicList(this.dealerId ?? '');
      }
    })
  }

  onDealerChange(value) {
    this.isDealerRequired = !value;
    this.mechanicId = null;
    this.selectedDealer();
  }

  selectedDealer() {
    this.isMechanicSelected = false;
    this.selectedMechanic = 0;
    this.isMechanicRequired = false;
    this.GetMechanicList(this.dealerId ?? '');
  }

  async GetMechanicList(id: string) {
    this.spinner.show();
    await this.mechanicService.GetMechanicList(id, Enums.StatusCode.Active).then(response => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.mechanicList = response.responseObject;
      }
      this.spinner.hide();
    });
  }

  onSelectMechanic(e: any) {
    this.isMechanicRequired = !e || e <= 0;
    this.mechanicId = e;

    if (this.mechanicId && this.mechanicId > 0) {
      this.isMechanicSelected = true;
      this.isSearched = true;
      this.dealerName = this.dealers.filter(x => x.dealerId === this.dealerId)[0]?.name;
      this.timeStampList = [];
      this.requestModel.startRecordNumber = 0;
    } else {
      this.isMechanicSelected = false;
      this.isSearched = false;
    }
  }

  private validateForm(): boolean {
    let isValid = true;
    this.isDealerRequired = !this.dealerId;
    if (this.isDealerRequired) {
      isValid = false;
      this.toastr.error(this.translate.instant('lblRequiredDealer'));
    }
    this.isMechanicRequired = !this.mechanicId || this.mechanicId <= 0;
    if (this.isMechanicRequired) {
      isValid = false;
      this.toastr.error(this.translate.instant('lblRequiredMechanic'));
    }
    return isValid;
  }

  async getTimeStampReport() {
    if (!this.validateForm()) {
      return;
    }

    this.spinner.show();
    this.requestModel.dealerId = this.dealerId;
    this.requestModel.mechanicId = this.mechanicId;
    this.requestModel.IsDocument = false;

    await this.mechanicService.GetTimeStampReport(this.requestModel)
      .then(result => {
        if (result.responseCode === Constant.SuccessResponseCode) {
          if (this.IsDocument) {
            this.exportTimeStampList.push(...result.responseObject);
          } else {
            this.timeStampList.push(...result.responseObject);
            if (this.timeStampList?.length) {
              this.totalCount = this.timeStampList[0].totalCount;
              this.timeStampList.forEach(element => {
                element.stampIn = new Date(element.stampIn + 'Z');
                element.stampOut = element.stampOut ? new Date(element.stampOut + 'Z') : null;
              });


            }
          }
        } else {
          if (!this.IsDocument) {
            this.totalCount = 0;
            this.timeStampList = [];
          }
        }
        this.spinner.hide();
      });
  }

  onScrollDown() {
    if (this.totalCount > this.timeStampList?.length) {
      this.requestModel.startRecordNumber = this.timeStampList.length
      this.getTimeStampReport();
    }
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.requestModel.sortColumn = column;
    this.requestModel.sortDirection = direction;
    this.requestModel.startRecordNumber = 0;
    this.timeStampList = [];
    this.getTimeStampReport();
  }

  onSearchReport() {
    if (!this.validateForm()) {
      return;
    }

    let stampInDateFormatted = this.getFormattedDate(this.stampInDate);
    this.isSingleDateSelected = this.stampInDate[0] && this.stampInDate[1] && new Date(this.stampInDate[0]).getTime() === new Date(this.stampInDate[1]).getTime();
    this.requestModel.dateRange = stampInDateFormatted;
    this.requestModel.startRecordNumber = 0;
    this.timeStampList = [];

    if (this.isSingleDateSelected) {
      this.getTimeStampDetails();
    } else {
      this.getTimeStampReport();
    }
  }

  onReset() {
    this.dealerId = null;
    this.mechanicId = null;
    this.selectedMechanic = 0;
    this.isMechanicSelected = false;
    this.isSearched = false;
    this.isDealerRequired = false;
    this.isMechanicRequired = false;
    this.timeStampList = [];
    this.timeStampDetails = [];
    this.timeStampReport = [];
    this.totalCount = 0;
    this.exportTimeStampList = [];
    this.exportTimeStampReport = [];
    this.IsDocument = false;
    this.setDefaultCurrentMonth();
    this.mechanicList = [];
    this.cdr.detectChanges();
  }

  refresh() {
    this.onSearchReport();
  }

  // Excel Export Functionality 
  public async exportAsXLSX(): Promise<void> {
    if (await this.validateExport()) {
      const excelData = this.mapExportData();
      this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblTimeStampReport')}`);
    }
  }

  // PDF Export Functionality 
  public async exportAsPDF(): Promise<void> {
    if (await this.validateExport()) {
      const pdfData = this.mapExportData();
      const orientation = this.isSingleDateSelected ? 'landscape' : 'portrait';
      const doc = new jsPDF({ orientation });

      autoTable(doc, {
        head: [this.getExportHeaders()],
        body: pdfData.map(row => Object.values(row)),
        margin: { top: 3, left: 3, right: 3, bottom: 3 },
        styles: { fontSize: 8 },
        columnStyles: this.getColumnStyles()
      });
      doc.save(`${this.translate.instant('lblTimeStampReport')}.pdf`);
    }
  }

  private async validateExport(): Promise<boolean> {
    if (!this.dealerId) {
      this.isDealerRequired = true;
      return false;
    }

    if (!this.mechanicId || this.mechanicId <= 0) {
      this.isMechanicRequired = true;
      return false;
    }

    if (this.isSingleDateSelected) {
      if (this.exportTimeStampReport.length === 0) {
        await this.loadExportTimeStampDetails();
      }
      if (this.exportTimeStampReport.length === 0) {
        this.toastr.error(this.translate.instant('lblDataNotAvailable'));
        return false;
      }
    } else {
      if (this.exportTimeStampList.length === 0) {
        await this.loadExportTimeStampReport();
      }
      if (this.exportTimeStampList.length === 0) {
        this.toastr.error(this.translate.instant('lblDataNotAvailable'));
        return false;
      }
    }
    return true;
  }

  private async loadExportTimeStampReport(): Promise<void> {
    this.IsDocument = true;
    this.exportTimeStampList = [];

    // Create a copy of request model for export
    const exportRequestModel = { ...this.requestModel };
    exportRequestModel.startRecordNumber = 0;
    exportRequestModel.pageSize = 1;
    exportRequestModel.IsDocument = true
    this.spinner.show();
    exportRequestModel.dealerId = this.dealerId;
    exportRequestModel.mechanicId = this.mechanicId;
    let stampInDateFormatted = this.getFormattedDate(this.stampInDate);
    exportRequestModel.dateRange = stampInDateFormatted;

    await this.mechanicService.GetTimeStampReport(exportRequestModel)
      .then(result => {
        if (result.responseCode === Constant.SuccessResponseCode) {
          this.exportTimeStampList = result.responseObject;
          this.exportTimeStampList.forEach(element => {
            element.stampIn = new Date(element.stampIn + 'Z');
            element.stampOut = element.stampOut ? new Date(element.stampOut + 'Z') : null;
          });

        }
        this.spinner.hide();
      });

    this.IsDocument = false;
  }

  private async loadExportTimeStampDetails(): Promise<void> {
    let stampInDateFormatted = this.getFormattedDate(this.stampInDate);
    this.exportTimeStampReport = [];
    this.spinner.show();
    this.language = this.cookieservice.get('userSelectedLanguage');

    let requestBody = {
      languageCode: this.language,
      fromDate: stampInDateFormatted.split('-')[0],
      mechanicId: this.mechanicId,
      dealerId: this.dealerId,
      toDate: stampInDateFormatted.split('-')[1]
    };

    await this.mechanicService.GetTimeStampDetails(requestBody)
      .then(result => {
        if (result.responseCode === Constant.SuccessResponseCode) {
          const exportTimeStampDetails = result.responseObject;
          exportTimeStampDetails.forEach(t => {
            if (t?.timeStampDetails.length) {
              this.exportTimeStampReport.push(...t.timeStampDetails.map(d => {
                return {
                  mechanicNumber: t.mechanicNumber,
                  name: t.name,
                  stampIn: new Date(t.stampIn + 'Z'),
                  stampOut: new Date(t.stampOut + 'Z'),
                  totalTime: t.totalTime,
                  timeConsumed: d.timeConsumed,
                  appointmentJobId: d.appointmentJobId,
                  timeCode: d.timeCode,
                  workOrderNo: d.workOrderNo,
                  startTime: new Date(d.startTime + 'Z'),
                  endTime: new Date(d.endTime + 'Z')
                } as TimeStampReportModel;
              })
              )
            } else {
              this.exportTimeStampReport.push({
                mechanicNumber: t.mechanicNumber,
                name: t.name,
                stampIn: t.stampIn,
                stampOut: t.stampOut,
                totalTime: t.totalTime,
                timeConsumed: '',
                appointmentJobId: 0,
                timeCode: '',
                workOrderNo: '',
                startTime: null,
                endTime: null
              });
            }
          });
        }
        this.spinner.hide();
      });
  }

  private mapExportData(): any[] {
    if (this.isSingleDateSelected) {
      return this.exportTimeStampReport.map((item, index) => ({
        [this.translate.instant('lblNo')]: index + 1,
        [this.translate.instant('lblMechanicNumber')]: item.mechanicNumber,
        [this.translate.instant('lblMechanicName')]: item.name,
        [this.translate.instant('lblWoNo')]: item.workOrderNo,
        [this.translate.instant('lblJobNo')]: item.appointmentJobId,
        [this.translate.instant('lblTimeCode')]: item.timeCode,
        [this.translate.instant('lblStampIn')]: this.datePipe.transform(item.stampIn, this.dateTimeFormat),
        [this.translate.instant('lblStampOut')]: this.datePipe.transform(item.stampOut, this.dateTimeFormat),
        [this.translate.instant('lblStartTime')]: this.datePipe.transform(item.startTime, this.dateTimeFormat),
        [this.translate.instant('lblEndTime')]: this.datePipe.transform(item.endTime, this.dateTimeFormat),
        [this.translate.instant('lblStandardTime')]: item.totalTime,
        [this.translate.instant('lblTimeConsumed')]: item.timeConsumed
      }));
    } else {
      return this.exportTimeStampList.map((item, index) => ({
        [this.translate.instant('lblNo')]: index + 1,
        [this.translate.instant('lblMechanicNumber')]: item.mechanicNumber,
        [this.translate.instant('lblMechanicName')]: item.name,
        [this.translate.instant('lblStampIn')]: this.datePipe.transform(item.stampIn, this.dateTimeFormat),
        [this.translate.instant('lblStampOut')]: this.datePipe.transform(item.stampOut, this.dateTimeFormat),
        [this.translate.instant('lblStandardTime')]: item.totalTime,
        [this.translate.instant('lblTimeConsumed')]: item.timeConsumed
      }));
    }
  }

  private getExportHeaders(): string[] {
    if (this.isSingleDateSelected) {
      return [
        this.translate.instant('lblNo'),
        this.translate.instant('lblMechanicNumber'),
        this.translate.instant('lblMechanicName'),
        this.translate.instant('lblWoNo'),
        this.translate.instant('lblJobNo'),
        this.translate.instant('lblTimeCode'),
        this.translate.instant('lblStampIn'),
        this.translate.instant('lblStampOut'),
        this.translate.instant('lblStartTime'),
        this.translate.instant('lblEndTime'),
        this.translate.instant('lblStandardTime'),
        this.translate.instant('lblTimeConsumed')
      ];
    } else {
      return [
        this.translate.instant('lblNo'),
        this.translate.instant('lblMechanicNumber'),
        this.translate.instant('lblMechanicName'),
        this.translate.instant('lblStampIn'),
        this.translate.instant('lblStampOut'),
        this.translate.instant('lblStandardTime'),
        this.translate.instant('lblTimeConsumed')
      ];
    }
  }

  private getColumnStyles(): any {
    if (this.isSingleDateSelected) {
      return {
        0: { cellWidth: 16 },
        1: { cellWidth: 25 },
        2: { cellWidth: 30 },
        3: { cellWidth: 25 },
        4: { cellWidth: 25 },
        5: { cellWidth: 20 },
        6: { cellWidth: 25 },
        7: { cellWidth: 25 },
        8: { cellWidth: 25 },
        9: { cellWidth: 25 },
        10: { cellWidth: 25 },
        11: { cellWidth: 25 }
      };
    } else {
      return {
        0: { cellWidth: 19 },
        1: { cellWidth: 22 },
        2: { cellWidth: 35 },
        3: { cellWidth: 32 },
        4: { cellWidth: 32 },
        5: { cellWidth: 32 },
        6: { cellWidth: 32 }
      };
    }
  }

  async getTimeStampDetails(content = null, item = null, generatePdf: boolean = false) {
    let stampInDateFormatted = this.getFormattedDate(this.stampInDate);
    this.timeStampReport = [];
    this.spinner.show();
    this.language = this.cookieservice.get('userSelectedLanguage')
    let stampInDate = item?.stampIn ? new Date(item.stampIn) : new Date();

    let requestBody = {
      languageCode: this.language,
      fromDate: this.isSingleDateSelected || generatePdf ? stampInDateFormatted.split('-')[0] : this.datePipe.transform(stampInDate, 'dd/MM/yyyy'),
      mechanicId: this.mechanicId,
      dealerId: this.dealerId,
      toDate: generatePdf ? stampInDateFormatted.split('-')[1] : null
    };

    await this.mechanicService.GetTimeStampDetails(requestBody)
      .then(result => {
        if (result.responseCode === Constant.SuccessResponseCode) {
          this.timeStampDetails = result.responseObject;
          this.timeStampDetails.forEach(element => {
            element.stampIn = new Date(element.stampIn + 'Z');
            element.stampOut = new Date(element.stampOut + 'Z');
            if (Array.isArray(element.timeStampDetails)) {
              element.timeStampDetails.forEach(detail => {
                detail.startTime = new Date(detail.startTime + 'Z');
                detail.endTime = detail.endTime ? new Date(detail.endTime + 'Z') : null;
              });
            }
          });
        } else {
          this.timeStampDetails = [];
        }
        this.spinner.hide();

        if (this.isSingleDateSelected || generatePdf) {
          this.timeStampDetails.forEach(t => {
            if (t?.timeStampDetails.length) {
              this.timeStampReport.push(...t.timeStampDetails.map(d => {
                return {
                  mechanicNumber: t.mechanicNumber,
                  name: t.name,
                  stampIn: t.stampIn,
                  stampOut: t.stampOut,
                  totalTime: t.totalTime,
                  timeConsumed: d.timeConsumed,
                  appointmentJobId: d.appointmentJobId,
                  timeCode: d.timeCode,
                  workOrderNo: d.workOrderNo,
                  startTime: new Date(d.startTime + 'Z'),
                  endTime: new Date(d.endTime + 'Z')
                } as TimeStampReportModel;
              })
              )
            } else {
              this.timeStampReport.push({
                mechanicNumber: t.mechanicNumber,
                name: t.name,
                stampIn: t.stampIn,
                stampOut: t.stampOut,
                totalTime: t.totalTime,
                timeConsumed: '',
                appointmentJobId: 0,
                timeCode: '',
                workOrderNo: '',
                startTime: null,
                endTime: null
              });
            }
          });
        } else {
          this.modal = this.modalService.open(content, { size: 'xl', windowClass: 'd-block modal pop-mh20 pop-wid1200' })
        }
      });
  }

  onDateRangeChanged(event) {
    if(event?.length === 2) {
      let eventFormatted = this.getFormattedDate(event);
      if (!eventFormatted) {
        this.onDateSelectionCleared();
      }
    }
  }

  onDateSelectionCleared() {
    let warningmsg = this.translate.instant("lblShowingCurrentMonthData");
    this.toaster.warning(warningmsg);
    this.setDefaultCurrentMonth();
    this.cdr.detectChanges();
  }

  getFormattedDate(dateRangeArray: any[]) {
    let formattedDate: string = "";
    if (dateRangeArray.length != 0) {
      let beginDate = this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate = this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate = beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
